import { render } from "./InfluencerViewPage.vue?vue&type=template&id=0ba1a6a0&scoped=true"
import script from "./InfluencerViewPage.vue?vue&type=script&lang=js"
export * from "./InfluencerViewPage.vue?vue&type=script&lang=js"

import "./InfluencerViewPage.vue?vue&type=style&index=0&id=0ba1a6a0&scoped=true&lang=css"

import exportComponent from "/Users/alvinpascasio/pjf-wine-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ba1a6a0"]])

export default __exports__